import FormComponent from '../utils/FormComponent';
import * as blockUtils from '../../utils/BlockUtils';
import * as api from '../../api/management-api';
import i18next from 'i18next';
import * as viewUtils from '../../utils/view-utils';
import ModalDialog from '../utils/ModalDialog';
import Form from '../utils/Form';
import TextInput from '../utils/TextInput';
import PropTypes from 'prop-types';
import React from 'react';

const TEXT_KEY = 'site_management.wkc_card.';

class WkcCardForm extends FormComponent {
  constructor(props) {
    super(props);

    this.sendForm = this.sendForm.bind(this);

    this.state = {
      serialNumber: '',
    };
  }

  initialState() {
    blockUtils.blockUI();
    api.getVkcCardForSite(this.props.siteId).then((response) => {
      const wkcCard = response.data;
      this.setState({
        serialNumber: wkcCard.serialNumber ? wkcCard.serialNumber : '',
      });
      blockUtils.unblockUI();
    }).catch((error) => {
      blockUtils.unblockUI();
      window.showAlert(i18next.t('error'), viewUtils.getErrorDescription(error));
    });
  }

  sendForm() {
    if (this.validateAllFields('wkc-card-form', TEXT_KEY) === false) {
      return;
    }

    const data = {
      siteId: this.props.siteId,
      serialNumber: this.state.serialNumber,
    };

    blockUtils.blockUI();
    api.updateVkcCardForSite(this.props.siteId, data).then((response) => {
      blockUtils.unblockUI();
      $(`#${this.props.dialogId}`).modal('hide');
      return response;
    }).catch((error) => {
      blockUtils.unblockUI();
      window.showAlert(i18next.t('error'), error.response.data.errorMessage);
    });
  }

  render() {
    return (
      <ModalDialog
        customClass="wkc-card-form"
        modalTitle={i18next.t('site_management.wkc_card.menu')}
        dialogId={this.props.dialogId}
        onDialogHide={blockUtils.unblockUI}
        onDialogShown={this.onFormShow}
        onSubmit={this.sendForm}>

        <Form>
          <TextInput
            fieldId="serialNumber"
            labelText={i18next.t('site_management.wkc_card.serialNumber')}
            onChange={this.onChange}
            value={this.state.serialNumber}
            isRequired={true}
            validate={() => this.validateField(TEXT_KEY, 'serialNumber')}
            error={this.state.serialNumberError}
          />

        </Form>
      </ModalDialog>
    );
  }
}

WkcCardForm.propTypes = {
  siteId: PropTypes.number,
  dialogId: PropTypes.string,
};

export default WkcCardForm;
